import "./css-components/home.css";
import { Link,Outlet } from "react-router-dom";


function Footermain(){

    return(
        <>
        <footer>
            <div className="container footer__container">
                <div className="footer__1">
                <Link to="/" className="footer__logo"><h4>Learners</h4></Link>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus, unde?</p>
                </div>

                <div className="footer__2">
                 <h4>Permalinks</h4>
                   <ul className="permalinks">
                   <li><Link to="/">Home</Link></li>
                   <li><Link to="/about">About</Link></li>
                   <li><Link to="/courses">Courses</Link></li>
                   <li><Link to="/contact">Contact</Link></li>
                   </ul>
                   <Outlet/>
                </div>

                <div className="footer__3">
                 <h4>Primacy</h4>
                   <ul className="privacy">
                   <li><Link to="#">Privacy Policy</Link></li>
                   <li><Link to="#">Terms and conditions</Link></li>
                   <li><Link to="#">Refund Policy</Link></li>
                   </ul>
                </div>

                <div className="footer__4">
                 <h4>Contact Us</h4>
                   <div>
                       <p><a href="tel:7749807715">+91-7749807715</a></p>
                       <p>techsagarsingh@gmail.com</p>
                   </div>
                   <ul className="footer__socials">
                    <li>
                        <a href="."><i class="fa-brands fa-facebook-f"></i></a>
                    </li>
                    <li>
                        <a href="."><i class="fa-brands fa-instagram"></i></a>
                    </li>
                    <li>
                        <a href="."><i class="fa-brands fa-twitter"></i></a>
                    </li>
                    <li>
                        <a href="."><i class="fa-brands fa-linkedin"></i></a>
                    </li>
                </ul>
                </div>
            
            </div>
            <div className="footer__copyright">
                    <small>Copyright &copy; Learners</small>
                </div>
        </footer>
        </>
    )

}
export default Footermain;